<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.03125 5.96875C7.03125 5.53728 7.38103 5.1875 7.8125 5.1875H9.375C9.80647 5.1875 10.1562 5.53728 10.1562 5.96875V20.0312C10.1562 20.4627 9.80647 20.8125 9.375 20.8125H7.8125C7.6053 20.8125 7.40659 20.7302 7.26007 20.5837C7.11356 20.4372 7.03125 20.2385 7.03125 20.0312L7.03125 5.96875ZM14.8437 5.96875C14.8437 5.53728 15.1935 5.1875 15.625 5.1875H17.1875C17.3947 5.1875 17.5934 5.26981 17.7399 5.41632C17.8864 5.56284 17.9688 5.76155 17.9688 5.96875L17.9688 20.0312C17.9688 20.4627 17.619 20.8125 17.1875 20.8125H15.625C15.1935 20.8125 14.8437 20.4627 14.8437 20.0312V5.96875Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPause',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>